import { render, staticRenderFns } from "./CourtToronto.vue?vue&type=template&id=2669fd95&scoped=true&"
import script from "./CourtToronto.vue?vue&type=script&lang=js&"
export * from "./CourtToronto.vue?vue&type=script&lang=js&"
import style0 from "./CourtToronto.vue?vue&type=style&index=0&id=2669fd95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2669fd95",
  null
  
)

export default component.exports